export default __webpack_public_path__ + "static/badge-enter-sale-4317f92cdcc0e0ee5268db835e570a66.webp";